import React from 'react';

export const AcceptIcon = ({ color }) => {
    return (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_638_3947)">
                <path
                    d="M34 17C34 21.5087 32.2089 25.8327 29.0208 29.0208C25.8327 32.2089 21.5087 34 17 34C12.4913 34 8.1673 32.2089 4.97918 29.0208C1.79107 25.8327 0 21.5087 0 17C0 12.4913 1.79107 8.1673 4.97918 4.97918C8.1673 1.79107 12.4913 0 17 0C21.5087 0 25.8327 1.79107 29.0208 4.97918C32.2089 8.1673 34 12.4913 34 17Z"
                    fill={color}
                />
                <path
                    d="M9.77351 15.7264C9.38299 15.3359 8.74982 15.3359 8.3593 15.7264C7.96878 16.1169 7.96878 16.7501 8.3593 17.1406L9.77351 15.7264ZM15.8664 23.2335L15.1593 23.9406C15.3597 24.141 15.6358 24.247 15.9188 24.2321C16.2019 24.2173 16.4653 24.083 16.6437 23.8627L15.8664 23.2335ZM26.277 11.9627C26.6245 11.5334 26.5582 10.9037 26.1289 10.5563C25.6997 10.2088 25.07 10.275 24.7225 10.7043L26.277 11.9627ZM8.3593 17.1406L15.1593 23.9406L16.5735 22.5264L9.77351 15.7264L8.3593 17.1406ZM16.6437 23.8627L26.277 11.9627L24.7225 10.7043L15.0892 22.6043L16.6437 23.8627Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_638_3947">
                    <rect width="34" height="34" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
